import React from 'react';
import PropTypes from 'prop-types';

const AmountSlider = ({ handleAmountPanels, title, min, max, value }) => {
  return (
    <>
      <section className="amount-slider">
        <div className="amount-slider__container">
          <h3 className="amount-slider__title">{title}</h3>
          <div className="amount-slider__display_amount">{value} paneler</div>
          <div className="amount-slider__input-container">
            <button
              className="amount-slider__input-adjust-button"
              onClick={() => {
                value > min && handleAmountPanels(value - 1);
              }}
            >
              -
            </button>
            <input
              className="amount-slider__input-slider"
              id="sunPanelsRange"
              type="range"
              min={min}
              max={max}
              value={value}
              onChange={({ target: { value: radius } }) => {
                handleAmountPanels(parseInt(radius));
              }}
            />
            <button
              className="amount-slider__input-adjust-button"
              onClick={() => {
                value < max && handleAmountPanels(value + 1);
              }}
            >
              +
            </button>
          </div>
          <div className="amount-slider__amount-info-container">
            <div className="amount-slider__amount-info">Min {min} paneler</div>
            <div className="amount-slider__amount-info">Max {max} paneler</div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AmountSlider;

AmountSlider.propTypes = {
  handleAmountPanels: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
